<div
  class="view-description"
  [ngClass]="{
    'view-description--layout-column': layout === 'column',
    'view-description--layout-drawer': layout === 'drawer'
  }">
  <div class="view-description__inner">
    <section>
      <div
        *ngIf="chapterDescription"
        class="view-description__body">
        <app-html [markdownText]="chapterDescription"></app-html>
      </div>
      
    </section>

  </div>
</div>